<div class="md-form md-outline mb-0 {{ marginTop ? 'mt-3' : 'mt-0' }}">
  <textarea [ngClass]="{ 'mb-0': !marginBottom }" [ngModel]="value" (ngModelChange)="onInput($event)" id="form-input" class="form-control textarea form-{{color}}" rows="1" type="text" mdbInput style="resize:none;"></textarea>
  <label for="form-input">{{ label | translate }}</label>
  <small *ngIf="isValid != undefined" id="form-input-help" class="form-text text-muted d-flex align-items-center">
    <i *ngIf="isValid" class="{{color}}-text fas fa-check-circle pr-1"></i>
    <i *ngIf="!isValid" class="text-warning fas fa-times-circle pr-1"></i>
    <span class="mr-auto">{{value.length}}/{{maxLength}} ({{ 'MINIMUM' | translate }}: {{minLength}})</span>
  </small>
</div>